"use client";

import { useContext } from "react";
import { FilterContext } from "./FilterContext";
import type { FilterContextValue } from "./types";
import type { BaseEntity } from "@/components/shared/UniversalCRMTable/types";

/**
 * Custom hook to access FilterContext
 * Throws error if used outside of provider
 */
export function useFilterContext<T extends BaseEntity = BaseEntity>(): FilterContextValue<T> {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterContext must be used within FilterContextProvider");
  }
  return context as FilterContextValue<T>;
}
